import { Profile } from 'oidc-client';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../core/models/RouteHelper';
import FederationTable from './FederationTable';

interface OwnProps {
    userProfile: Profile;
    wrappedComponentRef?: any;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(FederationTable);
